<div class="sidenav-content" cdkScrollable *ngIf="!submitting && !isLoading; else spinner">
	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()"
		[titleHeaderText]="('guarantee.register'|translate) +' - '+ ('guarantee.magnelisothers.long'|translate)">
		<button type="button" mat-flat-button (click)="saveGuarantee($event)">
			<span translate>issue.save.as.drafts</span>
			<mat-icon iconPositionEnd class="save-icon" svgIcon="action_save"></mat-icon>
		</button>
		<button type="submit" mat-flat-button color="primary" (click)="goToNextStep($event)">
			<span translate>issue.select.batches.action.next</span>
		</button>
	</copo-panel-header>
	<form>
		<div class="copo-form-container copo-grid">
			<copo-stepper class="copo-stepper-container" [steps]="steps"></copo-stepper>
			<copo-feedback-error></copo-feedback-error>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.customer.information</h2>
				</div>
			</div>
			<div class="copo-grid-row grid-template-columns">
				<div class="copo-grid-row-column" #nameDiv>
					<mat-form-field>
						<mat-label translate>guarantee.project.name</mat-label>
						<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="35"
							[formControl]="projectNameFormControl" (change)="projectNameChanged($event)" required>
						<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
						</mat-icon>
						<mat-error *ngIf="projectNameFormControl.hasError('required')"><span
								translate>guarantee.project.name.mandatory</span></mat-error>
					</mat-form-field>
				</div>
				<div class="copo-grid-row-column" #soldToDiv>
					<mat-form-field>
						<mat-label translate>guarantee.customer.name</mat-label>
						<mat-select (selectionChange)="soldToChanged($event)" [formControl]="soldToFormControl"
							required>
							<mat-option *ngFor="let corporate of soldTos" [value]="corporate.businessId">
								{{corporate.name}}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="soldToFormControl.hasError('required')"><span
								translate>guarantee.corporate.name.mandatory</span></mat-error>
					</mat-form-field>
				</div>
			</div>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.project.size</h2>
				</div>
			</div>
			<div class="copo-grid-row">
					<mat-form-field class="copo-grid-row-column-input">
						<mat-label translate>guarantee.tonnage.magnelis</mat-label>
						<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="10"
							[formControl]="magnelisTonnageFormControl" (change)="magnelisTonnageNameChanged($event)">
						<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
						</mat-icon>
					</mat-form-field>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.type.application</h2>
				</div>
			</div>
			<mat-radio-group name="application" class="copo-guarantee-radio-group" labelPosition="after"
				[formControl]="applicationTypeFormControl" (change)="applicationTypeChange($event)">
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-radio-button name="application" class="copo-guarantee-checkbox-placement" value="Silo">
							<span class="checkbox-label-wrapped" translate>guarantee.silo</span>
						</mat-radio-button>
						<ng-container *ngIf="applicationTypeFormControl.value === 'Silo'">
							<div class="copo-grid-row-column">
								<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
									(change)="onSiloBaseChange($event.checked)" [formControl]="siloBaseFormControl">
									<span class="checkbox-label-wrapped" translate>guarantee.silo</span>
								</mat-checkbox>
							</div>
							<div class="copo-grid-row">
								<mat-form-field class="copo-grid-row-column-input">
									<mat-label translate>guarantee.silo.products</mat-label>
									<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
										(change)="onSiloProductsStoredChange($event)"
										[formControl]="siloProductsStoredFormControl">
									<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
										class="image-draft-list-icon"></mat-icon>
								</mat-form-field>
							</div>
							<div class="copo-grid-row-radio">
								<div class="copo-grid-row-column copo-grid-row-column-left-margin">
									<span translate>guarantee.silo.liner</span>
								</div>
								<div class="copo-grid-row-column">
									<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
										(change)="onLinerInSiloChange($event)" [formControl]="linerInSiloFormControl">
										<mat-radio-button class="copo-guarantee-radio" [value]="true">
											<span translate>guarantee.radio.yes</span>
										</mat-radio-button>
										<mat-radio-button class=" copo-guarantee-radio" [value]="false">
											<span translate>guarantee.radio.no</span>
										</mat-radio-button>
									</mat-radio-group>
								</div>
							</div>
							<div class="copo-grid-row ">
								<div class="copo-grid-row-column">
									<span class="checkbox-label-wrapped" translate>guarantee.silo.parts</span>
								</div>
							</div>
							<div class="copo-grid-row">
								<div class="copo-grid-row-column">
									<mat-checkbox labelPosition="after" (change)="onSiloRoofChange($event.checked)"
										[formControl]="siloRoofFormControl">
										<span class="checkbox-label-wrapped" translate>guarantee.silo.roof</span>
									</mat-checkbox>
								</div>
							</div>
							<div class="copo-grid-row">
								<div class="copo-grid-row-column">
									<mat-checkbox labelPosition="after" (change)="onSiloCylinderChange($event.checked)"
										[formControl]="siloCylinderFormControl">
										<span class="checkbox-label-wrapped" translate>guarantee.silo.cylinder</span>
									</mat-checkbox>
								</div>
							</div>
							<div class="copo-grid-row">
								<div class="copo-grid-row-column">
									<mat-checkbox labelPosition="after"
										(change)="onSiloInContactSoilConcreteChange($event.checked)"
										[formControl]="siloInContactSoilConcreteFormControl">
										<span class="checkbox-label-wrapped" translate>guarantee.silo.soil</span>
									</mat-checkbox>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-radio-button name="application" class="copo-guarantee-checkbox-placement" value="Road restraint systems">
							<span class="checkbox-label-wrapped" translate>guarantee.road.restraint</span>
						</mat-radio-button>
						<ng-container *ngIf="applicationTypeFormControl.value === 'Road restraint systems'">
							<div class="copo-grid-row-column">
								<div class="copo-grid-row">
									<div class="copo-grid-row-column">
										<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
											[formControl]="rrsHorizontalFormControl"
											(change)="rrsHorizontalChanged($event.checked)">
											<span class="checkbox-label-wrapped" translate>guarantee.horizontal.rails</span>
										</mat-checkbox>
									</div>
								</div>
								<div class="copo-grid-row">
									<div class="copo-grid-row-column">
										<mat-checkbox class="copo-guarantee-checkbox-placement add-space"
											[formControl]="rrsMiscellaneousFormControl"
											(change)="rrsMiscellaneousChanged($event.checked)">
											<span class="checkbox-label-wrapped"
												translate>guarantee.rrs.miscellaneous</span>
										</mat-checkbox>
										<ng-container *ngIf="rrsMiscellaneousFormControl.value === true">
											<div class="copo-grid-row-radio">
												<div class="copo-grid-row-column copo-grid-row-column-left-margin">
													<span translate>guarantee.rrs.welded</span>
												</div>
												<div class="copo-grid-row-column">
													<mat-radio-group class="copo-guarantee-radio-group"
														labelPosition="before" [formControl]="rrsMagnelisWeldedFormControl"
														(change)="rrsMagnelisWeldedChanged($event)">
														<mat-radio-button class="copo-guarantee-radio"
															[value]="true">
															<span translate>guarantee.radio.yes</span>
														</mat-radio-button>
														<mat-radio-button class=" copo-guarantee-radio" [value]="false">
															<span translate>guarantee.radio.no</span>
														</mat-radio-button>
													</mat-radio-group>
												</div>
											</div>
										</ng-container>
									</div>
								</div>
								<div class="copo-grid-row">
									<div class="copo-grid-row-column">
										<mat-checkbox labelPosition="after" [formControl]="rrsPolesFormControl"
											(change)="rrsPolesChanged($event.checked)">
											<span class="checkbox-label-wrapped" translate>guarantee.rrs.poles</span>
										</mat-checkbox>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-radio-button name="application" class="copo-guarantee-checkbox-placement" value="Acoustic barriers">
							<span class="checkbox-label-wrapped" translate>guarantee.acoustic</span>
						</mat-radio-button>
						<ng-container *ngIf="applicationTypeFormControl.value === 'Acoustic barriers'">
							<div class="copo-grid-row">
								<div class="copo-grid-row-column">
									<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
										[formControl]="acoRoadTrafficFormControl"
										(change)="acoRoadTrafficChanged($event.checked)">
										<span class="checkbox-label-wrapped" translate>guarantee.acoustic.road.traffic
										</span>
									</mat-checkbox>
								</div>
							</div>
							<div class="copo-grid-row">
								<div class="copo-grid-row-column">
									<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
										[formControl]="acoRailroadFormControl"
										(change)="acoRailroadChanged($event.checked)">
										<span class="checkbox-label-wrapped" translate>guarantee.acoustic.railroad
										</span>
									</mat-checkbox>
								</div>
							</div>
							<br>
							<div class="copo-grid-row-radio">
								<div class="copo-grid-row-column copo-grid-row-column-left-margin">
									<span translate>guarantee.acoustic.concrete</span>
								</div>
								<div class="copo-grid-row-column">
									<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
										[formControl]="acoConcreteBaseFormControl"
										(change)="acoConcreteBaseChanged($event)">
										<mat-radio-button class="copo-guarantee-radio" [value]="true">
											<span translate>guarantee.radio.yes</span>
										</mat-radio-button>
										<mat-radio-button class=" copo-guarantee-radio" [value]="false">
											<span translate>guarantee.radio.no</span>
										</mat-radio-button>
									</mat-radio-group>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-radio-button name="application" class="copo-guarantee-checkbox-placement" value="Perforated sheet">
							<span class="checkbox-label-wrapped" translate>guarantee.perforated.sheet</span>
						</mat-radio-button>
						<ng-container *ngIf="applicationTypeFormControl.value === 'Perforated sheet'">
							<div class="copo-grid-row-column">
								<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
									[formControl]="peforatedSheetFormControl"
									(change)="peforatedSheetChanged($event.checked)">
									<span class="checkbox-label-wrapped" translate>guarantee.perforated.sheet
									</span>
								</mat-checkbox>
							</div>
							<div class="copo-grid-row-column">
								<mat-form-field class="copo-grid-row-column-input">
									<mat-label translate>guarantee.per.rich</mat-label>
									<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
										[formControl]="perPerRichFormControl" (change)="perPerRichChanged($event)">
									<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
										class="image-draft-list-icon"></mat-icon>
								</mat-form-field>
							</div>
							<div class="copo-grid-row-column">
								<mat-form-field class="copo-grid-row-column-input-1">
									<mat-label translate>guarantee.per.app</mat-label>
									<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
										[formControl]="perAppFormControl" (change)="perAppChanged($event)">
									<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
										class="image-draft-list-icon"></mat-icon>
								</mat-form-field>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-radio-button name="application" class="copo-guarantee-checkbox-placement" value="Other Applications">
							<span class="checkbox-label-wrapped" translate>guarantee.other</span>
						</mat-radio-button>
					</div>
					<div class="copo-grid-row-column">
						<ng-container *ngIf="applicationTypeFormControl.value === 'Other Applications'">
							<mat-form-field class="copo-grid-row-column">
								<mat-label translate>guarantee.other.application</mat-label>
								<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
									[formControl]="toaOtherApplicationFormControl"
									(change)="toaOtherApplicationChanged($event)">
								<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
									class="image-draft-list-icon"></mat-icon>
							</mat-form-field>
						</ng-container>
					</div>
				</div>
			</mat-radio-group>	
		</div>
	</form>
</div>
<ng-template #spinner>
	<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
</ng-template>